import apiCaller from '../../utils/apiCaller'

const INITIALIZE_USER = () => {
    return {
        name: null,
        birthday: null,
        managerCode: null,
        gender: null, // 1:남, 2:여
        authToken: null
    }
}

export const state = {
    user: INITIALIZE_USER(),
    home: '/',
    fcCode: ''
}

export const getters = {
    getUser: function (state) {
        return state.user;
    },
    getHome: function (state) {
        return state.home;
    },
    fcCode: state => state.fcCode
}

export const mutations = {
    SET_USER(state, user) {
        if (user.step === 1) {
            state.user.name = user.name
            state.user.birthday = user.birthday
            
            if(user.gender !== null) 
                state.user.gender = user.gender
        } else if (user.step === 2) {
            state.user.gender = user.gender
        }
    },
    SET_MANAGER_CODE(state, code) {
        state.user.managerCode = code
    },
    SET_AUTH_TOKEN(state, token) {
        state.user.authToken = token
    },
    LOGOUT(state, payload) {
        state.user = INITIALIZE_USER()
        console.log('LOGOUT', state)
    },
    SET_HOME(state, homeurl) {
        state.home = homeurl
    },
    SET_FC_CODE (state, fcCode) {
        state.fcCode = fcCode
    }
}

export const actions = {
    setUser({ commit }, payload) {
        commit('SET_USER', payload)
    },
    setManagerCode({ commit }, payload) {
        commit('SET_MANAGER_CODE', payload)
    },
    setAuthToken({commit}, payload) {
        commit('SET_AUTH_TOKEN', payload)
    },
    async signupWithCode({commit}, payload) {
        commit('SET_FC_CODE', payload)
        return await apiCaller.sign.signupWithCode(payload)
    },
    logout({commit}, payload) {
        commit('LOGOUT', payload)
    },
    setHome({ commit }, payload) {
        commit('SET_HOME', payload)
    }
}

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state
}
